import React, {createContext, PropsWithChildren, useContext, useState} from 'react';
import {NonExistentPrimitiveError, usePrimitives} from "@yosmanyga/primitive-ui-spec";

interface ToastContextType {
    show: (message: string) => void;
}

const ToastContext = createContext<ToastContextType>({
    show: () => {
        throw new Error('ToastContext is not implemented');
    },
});

const ToastProvider: React.FC = ({children}: PropsWithChildren) => {
    const [message, setMessage] = useState('');

    const {Toast: BaseToast} = usePrimitives()

    if (!BaseToast) {
        throw new NonExistentPrimitiveError('Toast')
    }

    const show = (message: string) => {
        setMessage(message);
    };

    return <ToastContext.Provider value={{
        show: show,
    }}>
        {children}
        {message && <BaseToast
            message={message}
            onShow={() => setMessage('')}
        />}
    </ToastContext.Provider>
};

const useToast = () => useContext(ToastContext);

export {
    ToastProvider,
    useToast
}